import { Scope } from 'bunja';
import { createScopeFromContext } from 'bunja/react';
import type { Store } from 'jotai/vanilla/store';
import { createContext } from 'react';

// 항상 값을 주입해서 사용할 것이기 때문에 기본값을 따로 제공하지 않음.
// `getDefaultStore()`를 사용하면 개발중 Hot Module Replacement후 첫 SSR 발생시 아래와 같은 에러가 발생함:
// Detected multiple Jotai instances. It may cause unexpected behavior with the default store. https://github.com/pmndrs/jotai/discussions/2044
const defaultStore = null as unknown as Store;

export const JotaiStoreContext = createContext<Store>(defaultStore);
// TODO: tsgo bug: type annotation required
export const JotaiStoreScope: Scope<Store> = createScopeFromContext(JotaiStoreContext);
